<template>
  <v-menu
    v-model="showCalendar"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    left
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        class="form-date-picker__text-field"
        :value="dateFormatted"
        append-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
        clearable
        outlined
        dense
        @click:clear="$emit('input', '')"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      :first-day-of-week="1"
      @input="showCalendar = false"
      :max="max"
      :min="min"
      :locale="currentLanguage"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment';

/**
 * Component FormDatePicker.vue
 *
 * @module FormDatePicker
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.4] app/src/APP_DASHBOARD/templates/components/Parts/FormDatePicker.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'FormDatePicker',
  props: {
    min: {
      type: String,
      required: false
    },
    max: {
      type: String,
      required: false
    },
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showCalendar: false,
    };
  },
  computed: {
    date: {
      get() {
        return this.value;
      },
      set(date) {
        this.$emit('input', date);
      },
    },
    dateFormatted() {
      if (!this.value) return '';
      return moment(this.value).format('DD.MM.YYYY');
    },
    currentLanguage() {
      return this.$store.getters.getCurrentLanguage
    }
  },
};
</script>
